/* eslint-disable max-lines-per-function */
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('DeleteDataService', DeleteDataService);

  DeleteDataService.$inject = [
    '$http',
    '$q'
  ];

  function DeleteDataService($http, $q) {
    //////////////////////////////////////////
    // Service declaration
    const service = {
      single,
      many,
      bulk,
      interval
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function single(date, types) {
      if (typeof date !== 'string') {
        date = moment(date).format(MOMENT_DATE_ENGLISH_FORMAT);
      }

      return $http.delete(`${SERVER}v1/registros`, {
        params: {
          tipos: types.join(),
          data: date
        }
      });
    }

    function many(ids, types) {
      return $http({
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER}v1/registros/destroy_many`,
        data: { tipos: types.join(), ids: [ids].flat() }
      });
    }

    function bulk(dates, types) {
      return dates.reduce((result, date) => result.then(() => single(date, types)), $q.resolve());
    }

    function interval(start, end, types) {
      start = moment(start);
      end = moment(end);
      const diff = end.diff(start, 'days');
      const dates = [];

      for (let i = 0; i <= diff; i++) {
        dates.push(start.format(MOMENT_DATE_ENGLISH_FORMAT));
        start.add(1, 'day');
      }

      return bulk(dates, types);
    }
  }
}());
